import { render } from "./DetailShowcase.vue?vue&type=template&id=66b47691"
import script from "./DetailShowcase.vue?vue&type=script&lang=js"
export * from "./DetailShowcase.vue?vue&type=script&lang=js"

import "./DetailShowcase.vue?vue&type=style&index=0&id=66b47691&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__